import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {buQualificationDetailUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {BuQualification} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * One BU qualification (`GET supplier_360/bu_qualification/{id}/`, §2.7) — the record detail
 * page's qualification rail. Disabled for company-wide records (`id` null).
 */
export function useBuQualificationQuery(id: number | null | undefined) {
    const url = buQualificationDetailUrl(id ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<BuQualification>(url)).data,
        enabled: Boolean(id),
    });
}
